import { useMutation } from '@apollo/react-hooks'
import { gql } from 'apollo-boost'
import {
  CreateNewMarketplaceListingMutation,
  CreateNewMarketplaceListingMutationVariables
} from './__generated__/CreateNewMarketplaceListingMutation'
import {
  CreateNewMarketplaceListingPropsMutation,
  CreateNewMarketplaceListingPropsMutationVariables
} from './__generated__/CreateNewMarketplaceListingPropsMutation'
import {
  CreateMarketplaceListingCadencePolicyMutation,
  CreateMarketplaceListingCadencePolicyMutationVariables
} from './__generated__/CreateMarketplaceListingCadencePolicyMutation'

const MUTATION = gql`
  mutation CreateNewMarketplaceListingMutation(
    $installable: String!
    $messageSet: String
    $title: String!
    $description: String!
    $releaseDate: Long!
  ) {
    createMarketplaceListing(
      input: {
        installable: $installable
        messageSet: $messageSet
        title: $title
        description: $description
        releaseDate: $releaseDate
        stagingOnly: true
      }
    ) {
      id
    }
  }
`

const PROPS_MUTATION = gql`
  mutation CreateNewMarketplaceListingPropsMutation($input: CreateMarketplaceListingPropsInputV2!) {
    createMarketplaceListingPropsV2(input: $input) {
      ... on MarketplaceListingPropsV2 {
        marketplaceListingId
        propsJson
      }
      ... on MarketplaceListingErrorV2 {
        type
        error
      }
    }
  }
`

const CADENCE_POLICY_MUTATION = gql`
  mutation CreateMarketplaceListingCadencePolicyMutation(
    $input: CreateMarketplaceListingCadencePolicyInputV2!
  ) {
    createMarketplaceListingCadencePolicyV2(input: $input) {
      ... on MarketplaceListingCadencePolicyV2 {
        marketplaceListingId
        policyJson
      }
      ... on MarketplaceListingErrorV2 {
        type
        error
      }
    }
  }
`

export const useCreateMarketplaceListing = () =>
  useMutation<CreateNewMarketplaceListingMutation, CreateNewMarketplaceListingMutationVariables>(MUTATION)

export const useCreateMarketplaceListingProps = () =>
  useMutation<CreateNewMarketplaceListingPropsMutation, CreateNewMarketplaceListingPropsMutationVariables>(
    PROPS_MUTATION
  )

export const useCreateMarketplaceListingCadencePolicy = () =>
  useMutation<
    CreateMarketplaceListingCadencePolicyMutation,
    CreateMarketplaceListingCadencePolicyMutationVariables
  >(CADENCE_POLICY_MUTATION)
